import { render } from "./DuyuruTercihleri.vue?vue&type=template&id=b9204206&scoped=true"
import script from "./DuyuruTercihleri.vue?vue&type=script&lang=js"
export * from "./DuyuruTercihleri.vue?vue&type=script&lang=js"

import "./DuyuruTercihleri.vue?vue&type=style&index=0&id=b9204206&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9204206"]])

export default __exports__